<template>
    <div>
        <h1 class="display-heading">Patient Appointment Requests</h1>

        <div class="table-responsive">
            <table ref="listTable" class="table table-hover">
                <colgroup>
                    <col width="50">
                    <col width="200">
                    <col width="150">
                    <col>
                    <col width="180">
                </colgroup>
                <thead>
                    <tr>
                        <th scope="col">#</th>
                        <th scope="col">Date</th>
                        <th scope="col">Time</th>
                        <th scope="col">Patient Name</th>
                        <th scope="col">Action</th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-show="appointmentList.length === 0">
                        <td :colspan="columnsCount" class="text-center font-italic">
                            {{isTableLoading ? "Loading Data": "No Data"}}
                        </td>
                    </tr>
                    <tr v-for="(appointment, index) in appointmentList" :key="index">
                        <th scope="row">{{index+1}}</th>
                        <td class="text-nowrap">{{appointment.date}}</td>
                        <td class="text-nowrap">
                            {{appointment.time}}
                        </td>
                        <td class="text-nowrap">{{appointment.patientName}}</td>
                        <td class="text-nowrap">
                            <router-link :to="{'name': 'doctor-appointment-detail', 'params': {'id' : appointment.id}}">View Appointment</router-link>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import moment from 'moment';
export default {
    'name': 'DoctorAppointmentRequests',
    data () {
        return {
            'appointmentList': [],
            'columnsCount': 1,
            'isTableLoading': true,
            'shouldUpdate': true
        };
    },
    mounted () {
        this.columnsCount = this.$refs.listTable.rows[0].cells.length;
        this.getAppointmentRequests();

        $('#rejectAppointmentModal').on('shown.bs.modal', function (e) {
            document.querySelector('#inputReason').focus();
        });
    },
    beforeRouteLeave (to, from, next) {
        this.shouldUpdate = false;
        next();
    },
    'methods': {
        getAppointmentRequests () {
            this.axios.post('Appointment/GetDoctorAppointments', {
                's': [0]
            }).then(({
                data
            }) => {
                this.isTableLoading = false;
                this.appointmentList = data.data.map((appointment) => ({
                    'id': appointment.ai,
                    'date': appointment.ss ? moment(appointment.ss).format('DD/MM/YYYY') : null,
                    'time': appointment.ss ? moment(appointment.ss).format('hh:mm A') : null,
                    'patientName': appointment.cp ? appointment.cp.fn : '-',
                    'rejectAppointmentId': '',
                    'rejectReason': ''
                }));

                if (this.shouldUpdate) {
                    setTimeout(() => {
                        this.getAppointmentRequests();
                    }, 2000);
                }
            })
                .catch(({
                    response
                }) => {

                });
        }
    }
};

</script>

<style>

</style>
